export const PIPELINE_DATA = {
  summary: {
    totalPipeline: '$1.2M',
    weightedPipeline: '$840K',
    winRate: '28%',
    avgCycle: '34 days',
    forecastAccuracy: '82%',
    avgDealSize: '$27K',
  },

  stages: [
    { name: 'Prospecting', count: 24, value: 312000, avgDays: 8, conversionRate: '50%' },
    { name: 'Qualified', count: 12, value: 284000, avgDays: 10, conversionRate: '67%' },
    { name: 'Proposal', count: 8, value: 196000, avgDays: 7, conversionRate: '63%' },
    { name: 'Negotiation', count: 5, value: 248000, avgDays: 12, conversionRate: '60%' },
    { name: 'Closed Won', count: 7, value: 164000, avgDays: 0, conversionRate: '—' },
  ],

  velocity: [
    { label: 'Avg. Days to Close', value: '34', data: [38, 36, 35, 34, 34], trend: '-3 days', trendUp: true },
    { label: 'Deals Created / Week', value: '6.2', data: [4, 5, 5.5, 5.8, 6.2], trend: '+14%', trendUp: true },
    { label: 'Win Rate', value: '28%', data: [32, 31, 30, 29, 28], trend: '-4%', trendUp: false, alert: true },
    { label: 'Pipeline Coverage', value: '3.2x', data: [2.8, 2.9, 3.0, 3.1, 3.2], trend: '+8%', trendUp: true },
    { label: 'Deals Won / Month', value: '7', data: [5, 6, 6, 7, 7], trend: '+15%', trendUp: true },
    { label: 'Weighted Pipeline', value: '$840K', data: [680, 720, 760, 800, 840], trend: '+10%', trendUp: true },
  ],

  forecast: {
    committed: { value: 164000, count: 7, label: 'Committed' },
    bestCase: { value: 248000, count: 5, label: 'Best Case' },
    pipeline: { value: 480000, count: 20, label: 'Pipeline' },
    target: 580000,
  },

  lostReasons: [
    { reason: 'Too expensive', count: 4, pct: 36 },
    { reason: 'Chose competitor', count: 3, pct: 27 },
    { reason: 'No decision / timing', count: 2, pct: 18 },
    { reason: 'Went with in-house', count: 1, pct: 9 },
    { reason: 'Other', count: 1, pct: 9 },
  ],
};

export const PIPELINE_CHAT_RESPONSES = {
  general: {
    text: "Here's your pipeline analysis.\n\nTotal pipeline is $1.2M with $840K weighted value. Pipeline coverage is 3.2x target — healthy. However, win rate has been declining for 4 weeks (32% → 28%), primarily due to pricing objections in the enterprise segment.\n\nThe biggest concern is stage conversion: deals are moving from Qualified → Proposal well (67%), but Negotiation → Close is only 60% — down from 72% last quarter.\n\nWant me to break down the conversion drop?",
  },
};
